import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { HiCheck } from "react-icons/hi";
import { capture } from "../instrument";

import API from "../api";
import { toast } from "react-hot-toast";
import { PASSWORD_MIN_LENGTH, hasPasswordLength, hasPasswordVariety, isPasswordStrong } from "../utils";

const Auth = () => {
  const history = useHistory();
  const [user, setUser] = useState({ password: "", passwordConfirm: "", token: "" });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    setUser((user) => ({ ...user, token }));
  }, []);

  const signin = async () => {
    if (!user.passwordConfirm || !user.password) return toast.error("Veuillez remplir tous les champs");
    if (user.password !== user.passwordConfirm) return toast.error("Les mots de passe ne correspondent pas");
    if (!isPasswordStrong(user.password)) return toast.error(`Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères et trois types de caractères`);

    try {
      const res = await API.post("/user/forgot_password_reset", user);
      if (!res.ok) return toast.error("Une erreur est survenue");

      toast.success("Mot de passe modifié avec succès");

      history.push("/");
    } catch (error) {
      capture(error);
      toast.error(error.message || error.code);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-black bg-opacity-75">
      <div className="min-w-96 min-h-56 bg-white flex justify-center items-center flex-col p-10 gap-1 rounded-md">
        <div className="font-bold text-xl mb-4">Querco Extraction</div>
        <div className="text text-gray-500 mb-4">Veuillez choisir un mot de passe</div>
        <input
          className="mb-1 p-3 w-full border-2 border-gray-300 rounded-md"
          type="password"
          value={user.password}
          onChange={(e) => setUser({ ...user, password: e.target.value })}
          placeholder="Mot de passe"
        />
        <input
          className="mb-1 p-3 w-full border-2 border-gray-300 rounded-md"
          type="password"
          value={user.passwordConfirm}
          onChange={(e) => setUser({ ...user, passwordConfirm: e.target.value })}
          placeholder="Confirmer le mot de passe"
        />
        <ul className="mb-4 w-full space-y-1 text-xs">
          <li className={`flex items-center gap-1.5 ${hasPasswordLength(user.password) ? "text-gray-700" : "text-gray-400"}`}>
            <HiCheck className="size-3.5 shrink-0" />
            {PASSWORD_MIN_LENGTH} caractères minimum
          </li>
          <li className={`flex items-center gap-1.5 ${hasPasswordVariety(user.password) ? "text-gray-700" : "text-gray-400"}`}>
            <HiCheck className="size-3.5 shrink-0" />
            Trois types de caractères parmi minuscules, majuscules, chiffres et spéciaux
          </li>
        </ul>
        <button
          className="rounded-md bg-primary-500 px-4 py-2 text-white disabled:cursor-not-allowed disabled:opacity-50"
          disabled={!isPasswordStrong(user.password) || user.password !== user.passwordConfirm}
          onClick={signin}
        >
          Valider
        </button>
      </div>
    </div>
  );
};

export default Auth;
